import React from 'react';
import './FloatingCartButton.css';
import { useCart } from '../contexts/CartContext';

interface FloatingCartButtonProps {
    onClick: () => void;
}

const FloatingCartButton: React.FC<FloatingCartButtonProps> = ({ onClick }) => {
    const { getTotalItems } = useCart();
    const totalItems = getTotalItems();

    if (totalItems === 0) return null;

    return (
        <button className="floating-cart-button" onClick={onClick} aria-label="Ver carrito">
            <div className="floating-cart-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
            </div>
            <span className="floating-cart-badge">{totalItems > 99 ? '99+' : totalItems}</span>
        </button>
    );
};

export default FloatingCartButton;
// End of component
